import NetworkingIndex from 'Pages/Networking';

export default [
	{ path: '/networking/:user?', component: NetworkingIndex, guards: ['auth', 'group:Staff'] },
];
